import React from 'react';
import { Card, IconWarning } from '@americanexpress/dls-react';

function Shutdown() {
    return (
        <>
            <div className="flex flex-justify-center">
                <div className="col-xs-12 text-align-center margin-4-t">
                    <IconWarning
                        size="lg"
                        theme={{
                            color: '#a83025 !important',
                            fill: '#a83025 !important'
                        }}
                    />
                </div>
            </div>
            <div className="col-xs-12 text-align-center">
                <p className="heading-4 pad dls-gray-04">We are sorry</p>
            </div>
            <div className="col-xs-12 text-align-center pad-4 margin-4-b">
                <p className="label-3 pad">We are temporarily pausing the acceptance of new proprietary Card applications in India as we integrate new platforms for our domestic Card issuing operations. We apologize for any inconvenience and appreciate your understanding.</p>
            </div>
        </>
    );
}

export default Shutdown;